<!-- 库存商品列表 -->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.AddComboSet" @click="showComboSetDialog(0, '')">{{
                    permission.AddComboSet
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">套包编号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" placeholder="套包编号"></el-input>
                <div class="search-name">套包名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                <div class="search-name">适用车型</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @cell-dblclick="handleDBClick">
                    <el-table-column min-width="160px" prop="APCode" label="套包编号" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="160px" prop="GoodName" label="套包名称" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="200px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="Unit" label="单位" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100px" prop="CateCount" label="商品种类数" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120" prop="GoodsCount" label="商品总数" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120" prop="Inventory" label="现有套包库存数" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="UpdateTime" label="最后更新时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="showSetDialog(1, scope.row.SetId)" v-if="permission.MakeSet">{{ permission.MakeSet }}</el-button>
                                <el-button type="text" size="mini" @click="showSetDialog(2, scope.row.SetId)" v-if="permission.SeparateSet">{{ permission.SeparateSet }}</el-button>
                                <el-button type="text" size="mini" @click="showComboSetDialog(2, scope.row.SetId)" v-if="permission.EditComboSet && scope.row.Inventory == 0">{{
                                    permission.EditComboSet
                                }}</el-button>
                                <el-button type="text" size="mini" style="color: red" @click="delSets(scope.row)" v-if="permission.DelComboSet && scope.row.Inventory == 0">{{
                                    permission.DelComboSet
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="setVisible" width="1200px">
            <div v-if="setVisible">
                <setDetails :SetId="setId" :Type="type" @closeDialog="closeSetDialog"></setDetails>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import setDetails from '@/components/business/goods/setDetails';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        breadcrumb,
        elTableColumn,
        setDetails
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            title: '新增套包',
            userMsg: userMsg,
            setId: '',
            type: 0,
            noData: false,
            setVisible: false, //编辑
            searchData: {
                LabelCode: '',
                EntpId: userMsg.EntpId,
                AutoSerise: '',
                APCode: '',
                BrandId: '',
                GoodName: '',
                Cate: '',
                page: 1,
                limit: 15
            },
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getPermission('SetsManagement');
    },
    methods: {
        showComboSetDialog(type, setId) {
            this.$router.push(`/inventoryManage/goods/sets/setEdit?type=${type}&SetId=${setId}`);
        },
        // 配件信息
        showSetDialog(type, id) {
            //type 1是组包，2是拆包
            if (id) {
                this.setId = id;
                this.type = type;
                if (type == 1) this.title = '组包操作';
                else if (type == 2) this.title = '拆包操作';
            }
            this.setVisible = true;
        },
        closeSetDialog(fresh) {
            if (fresh) {
                this.getTableData();
            }
            this.setVisible = false;
        },
        // 重置表单
        resetSearch() {
            this.goodsType = '';
            this.searchData = {
                LabelCode: '',
                EntpId: this.userMsg.EntpId,
                AutoSerise: '',
                APCode: '',
                BrandId: '',
                GoodName: '',
                Cate: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEnterpriseGoodsSets',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        delSets(row) {
            let that = this;
            that.$util.elConfirm({
                content: '确定删除该套包的设置吗？',
                noMsg: true,
                confirm() {
                    //传到接口调用打印出来
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/DelEnterpriseGoodsSets',
                            data: {
                                UserId: that.userMsg.EmployeeId,
                                SetId: row.SetId
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('成功删除包设置数据');
                                that.getTableData();
                            } else that.$util.successMsg(res.errmsg);
                        });
                }
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.SetId) {
                this.showComboSetDialog(1, event.SetId);
            }
        }
    }
};
</script>
